import React from "react";
import "./CreateServiceMain.css";
import strings from "../../../../utils/strings";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import ServiceType from "./ServiceType";
const dummyOptions = [
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
  { value: "relative", label: "Relative" },
  { value: "other", label: "Other" },
];
const CreateServiceMain = () => {
  const { t } = useTranslation();
  const breadcrumbs = ["nursingCare", "manageService", "createService"];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService, strings.navigation.createService];
  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="manage-service-heading">{t("createService")}</div>

      <div className="create-service-main">
        <div>
          {" "}
          <ServiceType />
        </div>
        <div className="whp-container">
          <div className="title-hr">
            <p>{t("priceWorkingHour")}</p>
            <hr />
          </div>
          <div className="service-type-main2">
            <div className="service-input-box">
              <span>
                {t("opdInterInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdLocalInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdSubsidized")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
          </div>
        </div>
        <div className="whp-container">
          <div className="title-hr2">
            <p>{t("priceNonWorkingHour")}</p>
            <hr />
          </div>
          <p className="clickable-text">{t("sameAsWorkingHour")}</p>
          <div className="service-type-main2">
            <div className="service-input-box">
              <span>
                {t("opdInterInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdLocalInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdSubsidized")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateServiceMain;
